import TagBoxTrangThaiHocSinh from './TagBoxTrangThaiHocSinh';
export default TagBoxTrangThaiHocSinh;